module.exports = __webpack_public_path__ + "static/media/moneymanager.e3d66e3f.png";